import type { AdminClientContext, AdminHttpClient } from './client.js';

type MethodKeys =
  | 'listCreditLimits'
  | 'upsertCreditLimit'
  | 'previewEffectiveCreditLimits'
  | 'deleteCreditLimit'
  | 'listQuotaProfiles'
  | 'createQuotaProfile'
  | 'updateQuotaProfile'
  | 'deactivateQuotaProfile'
  | 'previewQuotaProfileImpact'
  | 'listUserQuotaAssignments'
  | 'assignQuotaProfile'
  | 'clearQuotaProfilePin';

export function buildLimitsMethods(ctx: AdminClientContext) {
  const { transport, token, idemKey } = ctx;

  return {
    listCreditLimits: () => transport.listCreditLimits(token()),
    upsertCreditLimit: (input, idempotencyKey) =>
      transport.upsertCreditLimit(token(), {
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    previewEffectiveCreditLimits: (input) =>
      transport.previewEffectiveCreditLimits(token(), input),
    deleteCreditLimit: (id, idempotencyKey) =>
      transport.deleteCreditLimit(token(), {
        id,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),

    listQuotaProfiles: () => transport.listQuotaProfiles(token()),
    createQuotaProfile: (input, idempotencyKey) =>
      transport.createQuotaProfile(token(), {
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    updateQuotaProfile: (input, idempotencyKey) =>
      transport.updateQuotaProfile(token(), {
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    deactivateQuotaProfile: (id, idempotencyKey) =>
      transport.deactivateQuotaProfile(token(), {
        id,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    previewQuotaProfileImpact: (input) =>
      transport.previewQuotaProfileImpact(token(), input),
    listUserQuotaAssignments: (query) =>
      transport.listUserQuotaAssignments(token(), query),
    assignQuotaProfile: (input, idempotencyKey) =>
      transport.assignQuotaProfile(token(), {
        ...input,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
    clearQuotaProfilePin: (userId, idempotencyKey) =>
      transport.clearQuotaProfilePin(token(), {
        userId,
        idempotencyKey: idempotencyKey ?? idemKey(),
      }),
  } satisfies Pick<AdminHttpClient, MethodKeys>;
}
